/**
 * TaskManagement Module Routes (custom extensions)
 *
 * Extends the auto-generated routes with the Task Inbox page.
 * The generated routes provide standard CRUD views for WorkTask;
 * the inbox route is the primary user-facing entry point.
 */

import { taskmanagementRoutes as generatedRoutes } from './taskmanagement.generated';
import { TaskInboxPage } from '@/taskmanagement/TaskInboxPage';
import { TaskActionView } from '@/taskmanagement/TaskActionView';

export const taskmanagementRoutes = [
  ...generatedRoutes,
  {
    path: '/taskmanagement/inbox',
    element: <TaskInboxPage />,
  },
  {
    path: '/taskmanagement/inbox/:id',
    element: <TaskActionView />,
  },
];
